 import { Environment } from '@abp/ng.core';

const baseUrl = 'https://smartinvoicing-dev.upmuruguay.net';

const oAuthConfig = {
  issuer: 'https://smartinvoicing-backend-dev.upmuruguay.net/',
  redirectUri: baseUrl,
  clientId: 'SmartInvoicing_App',
  responseType: 'code',
  scope: 'offline_access SmartInvoicing',
  requireHttps: true,
  impersonation: {
    tenantImpersonation: true,
    userImpersonation: true,
  }
};

export const environment = {
  name: 'development',
  production: false,
  application: {
    baseUrl,
    name: 'SmartInvoicing',
  },
  oAuthConfig,
  apis: {
    default: {
      url: 'https://smartinvoicing-backend-dev.upmuruguay.net',
      rootNamespace: 'Upm.SmartInvoicing',
    },
    AbpAccountPublic: {
      url: oAuthConfig.issuer,
      rootNamespace: 'AbpAccountPublic',
    },
  },
  appVersion: '0.0.1',
  grafana: {
    isEnabled: false,
    url: 'https://faro-collector-prod-sa-east-1.grafana.net/collect/2063e8bbd264b153544d053fd2f36807',
  },
} as Environment;
